import { render, staticRenderFns } from "./restaurant-transaction.vue?vue&type=template&id=62fdb7e9&"
import script from "./restaurant-transaction.vue?vue&type=script&lang=js&"
export * from "./restaurant-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports